const name = 'invoice';

export const CREATE_INVOICE_REQUEST = `${name}/CREATE_INVOICE_REQUEST`;
export const CREATE_INVOICE_SUCCESS = `${name}/CREATE_INVOICE_SUCCESS`;
export const CREATE_INVOICE_FAILURE = `${name}/CREATE_INVOICE_FAILURE`;

export const GET_AVAILABLE_PLANS_REQUEST = `${name}/GET_AVAILABLE_PLANS_REQUEST`;
export const GET_AVAILABLE_PLANS_SUCCESS = `${name}/GET_AVAILABLE_PLANS_SUCCESS`;
export const GET_AVAILABLE_PLANS_FAILURE = `${name}/GET_AVAILABLE_PLANS_FAILURE`;

export const GET_AVAILABLE_MODULES_REQUEST = `${name}/GET_AVAILABLE_MODULES_REQUEST`;
export const GET_AVAILABLE_MODULES_SUCCESS = `${name}/GET_AVAILABLE_MODULES_SUCCESS`;
export const GET_AVAILABLE_MODULES_FAILURE = `${name}/GET_AVAILABLE_MODULES_FAILURE`;

export const GET_MODULES_LIST_REQUEST = `${name}/GET_MODULES_LIST_REQUEST`;
export const GET_MODULES_LIST_SUCCESS = `${name}/GET_MODULES_LIST_SUCCESS`;
export const GET_MODULES_LIST_FAILURE = `${name}/GET_MODULES_LIST_FAILURE`;

export const GET_LAST_INVOICE_REQUEST = `${name}/GET_LAST_INVOICE_REQUEST`;
export const GET_LAST_INVOICE_SUCCESS = `${name}/GET_LAST_INVOICE_SUCCESS`;
export const GET_LAST_INVOICE_FAILURE = `${name}/GET_LAST_INVOICE_FAILURE`;

export const GET_CURRENT_PLAN_REQUEST = `${name}/GET_CURRENT_PLAN_REQUEST`;
export const GET_CURRENT_PLAN_SUCCESS = `${name}/GET_CURRENT_PLAN_SUCCESS`;
export const GET_CURRENT_PLAN_FAILURE = `${name}/GET_CURRENT_PLAN_FAILURE`;

export const GET_PERSONAL_PLAN_REQUEST = `${name}/GET_PERSONAL_PLAN_REQUEST`;
export const GET_PERSONAL_PLAN_SUCCESS = `${name}/GET_PERSONAL_PLAN_SUCCESS`;
export const GET_PERSONAL_PLAN_FAILURE = `${name}/GET_PERSONAL_PLAN_FAILURE`;

export const PAYMENT_PERIODS = [
    { months: 1, title: '1 месяц', discount: 0 },
    { months: 3, title: "3 месяца", discount: 5 },
    { months: 6, title: "6 месяцев", discount: 10 },
    { months: 12, title: "12 месяцев", discount: 20 },
];

export default name;
